import { formatShortcut } from '../../shortcuts.ts';
import styles from './Kbd.module.css';

/**
 * A keyboard shortcut as a small key cap: `<Kbd combo="mod+k" />` shows "Ctrl K" (⌘K on a
 * Mac). Uses the same combo strings as `useShortcut`, so hints never drift from the keys.
 *
 * A key cap is a hint, so it is hidden on touch screens (coarse pointer or no hover), where
 * there is no keyboard to press it on. Buttons with a `shortcut` still expose it to screen
 * readers as `aria-keyshortcuts`. `persistent` keeps it visible, for the shortcuts list.
 */
export function Kbd({ combo, persistent = false }: { combo: string; persistent?: boolean }) {
  return (
    <kbd className={styles.kbd} data-persistent={persistent || undefined}>
      {formatShortcut(combo)}
    </kbd>
  );
}
